import App from './views/App.vue';
import router from './routes';
import {handlePrint} from "./custom-actions";
import WarehouseLoginForm from './views/WarehouseLoginForm.vue';
import {isWarehouseApp} from './warehouse-credentials';
import {installMenuStateFix} from './menu-state';

import AkApprovalStatusSelect from "./widgets/AkApprovalStatusSelect.vue";
import AkCartItemDisplay from "./widgets/AkCartItemDisplay.vue";
import AkPercentage from "./widgets/AkPercentage.vue";
import AkStockProductRelation from "./widgets/AkStockProductRelation.vue";

installMenuStateFix();

// The Blueprints CMS template should load this stylesheet. Some cached CMS
// templates only load the JavaScript bundle, so make the Vue app resilient to
// that and use the exact same cache-busting value as the active JS bundle.
const adminBundle = Array.from(document.scripts).find(script => /\/admin\/admin\.js(?:\?|$)/.test(script.src));
const adminStylesheet = adminBundle && adminBundle.src.replace(/admin\.js(\?.*)?$/, 'admin.css$1');
if (adminStylesheet && !Array.from(document.styleSheets).some(sheet => sheet.href === adminStylesheet)) {
    const stylesheet = document.createElement('link');
    stylesheet.rel = 'stylesheet';
    stylesheet.href = adminStylesheet;
    document.head.appendChild(stylesheet);
}

Vue.component('ak-approval-status-select', AkApprovalStatusSelect);
Vue.component('ak-cart-item-display', AkCartItemDisplay);
Vue.component('ak-percentage', AkPercentage);
Vue.component('ak-stock-product-relation', AkStockProductRelation);

if (isWarehouseApp()) {
    Vue.component('cms-login-form', WarehouseLoginForm);
}

let app = new Vue({
        data() { 
            return {
                globalMessages: []
            }
        },
        router,
        render: h => h(App),
        created() {
            this.$actionHandler.addAction('print', handlePrint);
        }
}).$mount('#app')

AppKit.init(app);
